(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("WalletConnectQRCodeModal", [], factory);
	else if(typeof exports === 'object')
		exports["WalletConnectQRCodeModal"] = factory();
	else
		root["WalletConnectQRCodeModal"] = factory();
})(this, function() {
return 